import { ReactElement } from 'react';

import styles from './UnreadNotificationsIndicator.module.scss';

const UnreadNotificationsIndicator = (): ReactElement => (
  <div className={styles.indicatorContainer} />
);

export default UnreadNotificationsIndicator;
